import { render } from "./ChallengesIcon.vue?vue&type=template&id=54b1b318"
import script from "./ChallengesIcon.vue?vue&type=script&lang=js"
export * from "./ChallengesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__